"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dataCy = exports.LONG_MENU_MIN_WIDTH = exports.LONG_MENU_MAX_WIDTH = void 0;
var _react = _interopRequireDefault(require("react"));
var _Divider = _interopRequireDefault(require("../Divider"));
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _Menu = _interopRequireDefault(require("../Menu"));
var _Stack = _interopRequireDefault(require("../Stack"));
var _ActionButton = _interopRequireDefault(require("./components/ActionButton"));
var _ActionIconButton = _interopRequireDefault(require("./components/ActionIconButton"));
var _ActionMenuItem = _interopRequireDefault(require("./components/ActionMenuItem"));
var _utils = require("./utils");
var _MoreVert = _interopRequireDefault(require("@mui/icons-material/MoreVert"));
var _styles = require("@mui/styles");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row'
    },
    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -12
    },
    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -12
    }
  };
}, {
  name: 'GgActions'
});
var ITEM_HEIGHT = 32;
var LONG_MENU_MAX_WIDTH = exports.LONG_MENU_MAX_WIDTH = 362;
var LONG_MENU_MIN_WIDTH = exports.LONG_MENU_MIN_WIDTH = 112;
var dataCy = exports.dataCy = 'Actions';
var Actions = function Actions(_ref) {
  var _hiddenActions$find;
  var children = _ref.children,
    limit = _ref.limit,
    _ref$spacing = _ref.spacing,
    spacing = _ref$spacing === void 0 ? 1 : _ref$spacing,
    activeId = _ref.activeId,
    className = _ref.className,
    variant = _ref.variant,
    color = _ref.color,
    iconProp = _ref.icon,
    tooltip = _ref.tooltip,
    edge = _ref.edge,
    anchorOrigin = _ref.anchorOrigin,
    transformOrigin = _ref.transformOrigin,
    onClick = _ref.onClick;
  var icon = iconProp || /*#__PURE__*/(0, _jsxRuntime.jsx)(_MoreVert["default"], {});
  var actionsClasses = useStyles();
  var actions = (0, _utils.getActionsArray)(children);
  var handleClick = function handleClick(action) {
    return function (e) {
      action === null || action === void 0 || action.onClick(e, {
        id: action.id
      });
      onClick === null || onClick === void 0 || onClick(action);
    };
  };
  var getCyActionProps = function getCyActionProps(action) {
    return {
      'data-cy-role': 'action',
      'data-cy-label': action.label,
      // TODO: remove after fixing test
      'data-cy-meta': 'Action',
      'data-cy-meta-label': action.label
    };
  };
  var iconCount = actions.length > limit ? Math.max(limit - 1, 0) : actions.length;
  var hiddenActions = actions.slice(iconCount);
  var metaHidden = JSON.stringify(hiddenActions.reduce(function (result, action) {
    if (action.children.length) {
      return [].concat(_toConsumableArray(result), _toConsumableArray(action.children.map(function (_ref2) {
        var label = _ref2.label;
        return label;
      })));
    } else {
      return [].concat(_toConsumableArray(result), [action.label]);
    }
  }, []));
  var isPrevItemGroup = true;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack["default"], {
    "data-cy": dataCy,
    className: (0, _clsx2["default"])(className, actionsClasses.root, _defineProperty(_defineProperty({}, actionsClasses.edgeStart, edge === 'start'), actionsClasses.edgeEnd, edge === 'end')),
    spacing: spacing,
    direction: 'row',
    children: [actions.slice(0, iconCount).map(function (action) {
      var metaDeclaration = JSON.stringify(action.children.reduce(function (result, subaction) {
        if (subaction.children.length) {
          return [].concat(_toConsumableArray(result), _toConsumableArray(subaction.children.map(function (_ref3) {
            var label = _ref3.label;
            return label;
          })));
        } else {
          return [].concat(_toConsumableArray(result), [subaction.label]);
        }
      }, []));
      if (action.children.length) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Menu["default"], {
          "data-cy-role": 'subActionMenu',
          PaperProps: {
            style: {
              minHeightmetaDeclaration: ITEM_HEIGHT * Math.min(hiddenActions.length, 1) + 16,
              minWidth: LONG_MENU_MIN_WIDTH,
              maxWidth: LONG_MENU_MAX_WIDTH
            }
          },
          anchorOrigin: _objectSpread({
            vertical: 'bottom',
            horizontal: 'left'
          }, anchorOrigin),
          transformOrigin: _objectSpread({
            vertical: 'top',
            horizontal: 'left'
          }, transformOrigin),
          anchor: action.button ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ActionButton["default"], _objectSpread({
            "data-cy-action": 'toggleSubActions',
            "data-cy-meta": metaDeclaration,
            action: action,
            variant: variant,
            tooltip: action.tooltip,
            color: color
          }, action.componentProps)) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_ActionIconButton["default"], _objectSpread({
            "data-cy-action": 'toggleSubActions',
            "data-cy-meta": metaDeclaration,
            action: action,
            tooltip: action.tooltip,
            color: color,
            badge: action.children.some(function (_ref4) {
              var badge = _ref4.badge;
              return badge;
            })
          }, action.componentProps)),
          children: action.children.map(function (subAction) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ActionMenuItem["default"], _objectSpread({
              action: subAction,
              onClick: subAction.onClick,
              badge: subAction.badge
            }, getCyActionProps(subAction)), subAction.id);
          })
        }, action.id);
      }
      if (action.custom) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react["default"].Fragment, {
          children: action.custom
        }, action.id);
      }
      if (action.button) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ActionButton["default"], _objectSpread(_objectSpread({
          action: action,
          activeId: activeId,
          onClick: action.onClick && handleClick(action),
          variant: variant,
          tooltip: action.tooltip,
          color: color
        }, action.componentProps), getCyActionProps(action)), action.id);
      }
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ActionIconButton["default"], _objectSpread(_objectSpread({
        action: action,
        activeId: activeId,
        onClick: action.onClick && handleClick(action),
        color: color,
        size: action.size
      }, action.componentProps), getCyActionProps(action)), action.id);
    }), hiddenActions.length ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Menu["default"], {
      "data-cy-role": 'longMenu',
      PaperProps: {
        style: {
          minHeight: ITEM_HEIGHT * Math.min(hiddenActions.length, 1) + 16,
          minWidth: LONG_MENU_MIN_WIDTH,
          maxWidth: LONG_MENU_MAX_WIDTH
        }
      },
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
      },
      anchor: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
        "data-cy-action": 'moreActions',
        "data-cy-meta": metaHidden,
        badge: (_hiddenActions$find = hiddenActions.find(function (action) {
          return action.badge !== undefined;
        })) === null || _hiddenActions$find === void 0 ? void 0 : _hiddenActions$find.badge,
        autoFocus: false,
        color: color,
        tooltip: tooltip,
        size: 'large',
        children: icon
      }),
      children: hiddenActions.reduce(function renderMenuItem(items, action, i, all) {
        var last = i === (all === null || all === void 0 ? void 0 : all.length) - 1;
        return [].concat(_toConsumableArray(items), _toConsumableArray(action.children.length ? [isPrevItemGroup ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider["default"], {
          style: {
            marginTop: 8,
            marginBottom: 8
          }
        }, "open_divider_".concat(action.id))].concat(_toConsumableArray(action.children.reduce(function (_items, _action) {
          for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            args[_key - 2] = arguments[_key];
          }
          return renderMenuItem.apply(void 0, [_items, _objectSpread(_objectSpread({}, _action), {}, {
            add: action.add
          })].concat(args));
        }, [])), [(isPrevItemGroup = true) && !last && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider["default"], {
          style: {
            marginTop: 8,
            marginBottom: 8
          }
        }, "close_divider_".concat(action.id))]) : [!(isPrevItemGroup = false) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ActionMenuItem["default"], _objectSpread(_objectSpread({
          id: action.id,
          action: action,
          onClick: action.onClick && handleClick(action)
        }, action.componentProps), getCyActionProps(action)), action.id)]));
      }, [])
    }) : null]
  });
};
Actions.propTypes = {
  spacing: _propTypes["default"].number,
  limit: _propTypes["default"].number
};
var _default = exports["default"] = Actions;